import { Rect } from './Rect';
import { Post } from './Post';
import { TextPost } from './textPost';
declare const THREE: any;

export class TerminationPost extends Post {

  static readonly Name = 'TerminationPost';

  private static tpTexture = new THREE.TextureLoader().load('assets/images/scene-plan/tp.png');
  text: string = null;
  labelPos: string;
  public modifiedAtStep3: boolean = false;


  constructor(type?: string, labelPos?: string) {
    super();
    this.add(new Rect(10, TerminationPost.tpTexture.clone()));
    if (labelPos) {
      this.labelPos = labelPos;
    } else {
      this.labelPos = "Center";
    }
    if (type) {
      type = type.toUpperCase()
      this.add(new TextPost(type, this.labelPos))
      this.text = type;
      // this.children.filter(ch => ch.name === TextPost.name).forEach(ch => {
      //   ch.setLabelPos();
      // });
    } else {
      this.text = null;
    }
    this.name = TerminationPost.Name;
  }

  duplicate() {
    let result;
    if (this.text) {
      result = new TerminationPost(this.text);
    } else {
      result = new TerminationPost();
    }
    result.modifiedAtStep3 = true;
    result.update();
    return result;
  }

  getInfo() {
    let pos = {
      x: this.position.x,
      y: this.position.y,
      z: this.position.z
    };
    let rot = {
      x: this.rotation.x,
      y: this.rotation.y,
      z: this.rotation.z
    }
    return {
      type: "TerminationPost",
      position: pos,
      rotation: rot,
      scaleCor: this.scaleCor,
      labelPos: this.labelPos,
      text: this.text
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Post/TerminationPost.ts